<footer class="abx-footer">
  <div class="abx-footer__inner container">
    <!-- Brand column -->
    <div class="abx-footer__brand">
      <div class="abx-footer__logo">
        <img src="./assets/logo-horizontal-dark.svg"
             alt="AppliedBioX"
             class="abx-footer__logo-img" />
      </div>
      <p class="abx-footer__tagline">
        Mobile hydrostatic body-composition testing — the gold standard, delivered to your gym.
      </p>
    </div>

    <!-- Service links (marketing home sections) -->
    <div class="abx-footer__col">
      <div class="eyebrow abx-footer__col-head">Service</div>
      <ul class="abx-footer__links">
        <li><a [href]="marketing.howItWorks" target="_blank" rel="noopener noreferrer">How it works</a></li>
        <li><a [href]="marketing.results" target="_blank" rel="noopener noreferrer">Results</a></li>
        <li><a [href]="marketing.science" target="_blank" rel="noopener noreferrer">The science</a></li>
        <li><a [href]="marketing.pricing" target="_blank" rel="noopener noreferrer">Pricing</a></li>
      </ul>
    </div>

    <!-- Company links (marketing pages) -->
    <div class="abx-footer__col">
      <div class="eyebrow abx-footer__col-head">Company</div>
      <ul class="abx-footer__links">
        <li><a [href]="marketing.about" target="_blank" rel="noopener noreferrer">About</a></li>
        <li><a [href]="marketing.partners" target="_blank" rel="noopener noreferrer">Partners</a></li>
        <li><a [href]="marketing.blog" target="_blank" rel="noopener noreferrer">Blog</a></li>
        <li><a [href]="marketing.contact" target="_blank" rel="noopener noreferrer">Contact</a></li>
      </ul>
    </div>

    <!-- Areas served -->
    <div class="abx-footer__col">
      <div class="eyebrow abx-footer__col-head">Areas served</div>
      <ul class="abx-footer__links abx-footer__areas">
        <li><span class="abx-footer__area">Dallas</span></li>
        <li><span class="abx-footer__area">Frisco</span></li>
        <li><span class="abx-footer__area">Plano</span></li>
        <li><span class="abx-footer__area">The Colony</span></li>
        <li><span class="abx-footer__area abx-footer__area--more">+ DFW metro</span></li>
      </ul>
    </div>
  </div>

  <!-- Bottom bar -->
  <div class="abx-footer__bottom">
    <div class="abx-footer__bottom-inner container">
      <span>© 2026 AppliedBioX · All rights reserved</span>
      <span class="abx-footer__region">Serving North Dallas and surrounding areas</span>
    </div>
  </div>
</footer>
